export default __webpack_public_path__ + "static/media/3_pilot_project.018dc7b9.png";